import { render, staticRenderFns } from "./EditStructure.vue?vue&type=template&id=3573339c&scoped=true&"
import script from "./EditStructure.vue?vue&type=script&lang=js&"
export * from "./EditStructure.vue?vue&type=script&lang=js&"
import style0 from "./EditStructure.vue?vue&type=style&index=0&id=3573339c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3573339c",
  null
  
)

export default component.exports